/* Hallmark · component: Section · genre: modern-minimal · theme: maeiz-tokens */
import React from "react";
import { clsx } from "clsx";

export interface SectionProps extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    padding?: "none" | "sm" | "md" | "lg";
    divided?: boolean;
}

export const Section: React.FC<SectionProps> = ({
    children,
    title,
    subtitle,
    actions,
    padding = "md",
    divided = false,
    className,
    ...props
}) => {
    const paddingStyles = {
        none: "",
        sm: "py-3",
        md: "py-6",
        lg: "py-10",
    };

    return (
        <section
            className={clsx(paddingStyles[padding], divided && "border-t border-neutral-border/70 dark:border-white/10", className)}
            {...props}
        >
            {(title || subtitle || actions) && (
                <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
                    <div className="min-w-0">
                        {title ? (
                            <h2 className="font-display text-xl font-semibold text-neutral-dark dark:text-white lg:text-2xl">
                                {title}
                            </h2>
                        ) : null}
                        {subtitle ? <p className="mt-1 text-sm text-neutral-secondary">{subtitle}</p> : null}
                    </div>
                    {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
                </div>
            )}
            {children}
        </section>
    );
};
